export default __webpack_public_path__ + "static/media/send_invitations.eaceb89c.svg";